import "./App.css";
import Footer from "./Footer";
import Home from "./Home";
import Checkout from "./Checkout";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LogIn from "./LogIn";
import ForgotPassword from "./ForgotPassword";
import NewPasswordLogin from "./NewPasswordLogin";
import { useEffect } from "react";
import { auth } from "./firebase";
import { useStateValue } from "./StateProvider";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import Orders from "./Orders";
import ReactGA from "react-ga4";
import {
  createTheme,
  ThemeProvider,
  responsiveFontSizes,
} from "@mui/material/styles";
import EmailFormV2 from "./EmailFormV2";
import SubtotalWithoutLogin from "./SubtotalWithoutLogin";
import CompanyOnboardin from "./CompanyOnboardin";
import Subtotal from "./Subtotal";
import ProductDetail from "./ProductDetail";
import ProductUploadForm from "./adminScreens/ProductUploadForm";
import Navbar from "./Navbar";
const promise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const theme = createTheme({
  typography: {
    h1: { fontSize: "3rem" },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 425,
      md: 768,
      lg: 1024,
      xl: 1280,
      "2xl": 1536,
      "3xl": 1920,
      "4xl": 2560,
      "5xl": 3200,
    },
  },
});

const MEASUREMENT_ID = "G-BWNNYW03HR"; // dfds
function App() {
  const [{}, dispatch] = useStateValue();
  useEffect(() => {
    auth.onAuthStateChanged((authUser) => {
      // whenever a page is refreshed , we must recover user lost info due to refresh:
      if (authUser) {
        // if user is looged in, dispatch a user obj to global storage
        dispatch({ type: "SET_USER", user: authUser });
      } else {
        //if user is logged out dispatch that user's obj to global storage
        dispatch({ type: "SET_USER", user: null });
      }
    });
    ReactGA.initialize(MEASUREMENT_ID);
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/Home", title: "Landing Page" });
  }, []);
  return (
    <>
      <ThemeProvider
        theme={responsiveFontSizes(theme, {
          breakpoints: [
            "xs",
            "sm",
            "md",
            "lg",
            "xl",
            "2xl",
            "3xl",
            "4xl",
            "5xl",
          ],
          factor: 3,
        })}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "100px" }}>
          <Router>
            <Navbar />
            <div className="app">
              <Routes>
                <Route path="/EmailForm" element={<EmailFormV2 />} />
                <Route path="/LogIn" element={<LogIn />} />
                <Route path="/ForgotPassword" element={<ForgotPassword />} />
                <Route
                  path="/NewPasswordLogin"
                  element={<NewPasswordLogin />}
                />
                <Route
                  path="/ProductUploadForm"
                  element={<ProductUploadForm />}
                />
              </Routes>
              <Elements stripe={promise}>
                <Routes>
                  <Route
                    path="/SubtotalWithoutLogin"
                    element={<SubtotalWithoutLogin />}
                  />
                  <Route path="/Subtotal" element={<Subtotal />} />
                  <Route path="/ProductDetail" element={<ProductDetail />} />

                  <Route
                    path="/CompanyOnboardin"
                    element={<CompanyOnboardin />}
                  />
                  <Route path="/Orders" element={<Orders />} />
                </Routes>
              </Elements>
              <Routes>
                <Route path="" element={<Home />} />
                <Route path="/Home#productClickedId" element={<Home />} />
                <Route path="/Home" element={<Home />} />
                <Route path="/Home/:productId" element={<Home />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/emailForm2" element={<EmailFormV2 />} />
              </Routes>
            </div>
          </Router>
          <Router>
            <Routes>
              <Route path="*" element={<Footer />} />
            </Routes>
          </Router>
        </div>
      </ThemeProvider>
    </>
  );
}

export default App;
